async function toDataURL(url) {
  const blob = await fetch(url).then((res) => res.blob());
  return URL.createObjectURL(blob);
}

async function download(file) {
  const a = document.createElement('a');
  a.href = await toDataURL(file);
  a.download = `workforceImage${Math.random()}.png`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

// eslint-disable-next-line import/prefer-default-export
export function downloadImage() {
  const downloadBtns = document.getElementsByClassName('download-image-block');
  downloadBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.paragraph--type--image-block');
      const imgSource = parent
        .querySelector('.field--name-field-image img')
        .getAttribute('src');
      download(imgSource);
    });
  });
}
